import React from 'react';
import PropTypes from 'prop-types';
import Section from '../Section/section';
import { connect } from 'react-redux';
import { getReferenceNumber } from '../../selectors';

export const ApplicationDecisionPage = (props) => {
  return (
    <Section className="applicationDecision">
      <h2 className="spaced-header text-grey">application reference number</h2>
      <p id="reference-number" className="reference-number">{props.referenceNumber}</p>
      <a href="/clapply/cl/CLLogin.action?autoLogin" className="button">go to application center</a>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col col-lg-6">
            <p>Use this number to access the online Application Center, where you'll be able to track the progress of
              your loan application.</p>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col col-lg-6">
            <p className="text-grey subtext">Additional information and updates will be sent to your email address.</p>
          </div>
        </div>
      </div>
    </Section>
  );
};

ApplicationDecisionPage.propTypes = {
  referenceNumber: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  referenceNumber: getReferenceNumber(state)
});

export default connect(mapStateToProps)(ApplicationDecisionPage);

